<template>
  <div class="auth-container">
    <div class="auth-card">
      <div class="spinner-wrapper">
        <svg class="spinner" width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="32" cy="32" r="28" stroke="#00235C" stroke-width="6" stroke-linecap="round" stroke-dasharray="175" stroke-dashoffset="87.5"/>
        </svg>
      </div>
      <h2 class="auth-title">{{ mensagem }}</h2>
      <p class="auth-subtitle">Aguarde um momento...</p>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ChamadoAuth',
  data() {
    return {
      mensagem: 'Autenticando'
    };
  },
  async mounted() {
    await this.processarAutenticacao();
  },
  methods: {
    ...mapActions({
      externalSignIn: 'auth/externalSignIn'
    }),
    async processarAutenticacao() {
      try {
        // Captura os parâmetros da URL
        const token = this.$route.query.token;
        const chamadoId = this.$route.query.id;

        // Valida se os parâmetros existem
        if (!token || !chamadoId) {
          this.$swal({
            icon: 'error',
            title: 'Link inválido',
            text: 'O link de acesso está incompleto ou inválido.',
          }).then(() => {
            this.$router.push('/login');
          });
          return;
        }

        this.mensagem = 'Autenticando';

        // Faz login com o token
        const response = await this.externalSignIn(token);

        if (response && response.status === 200 && response.data.success) {
          this.mensagem = 'Redirecionando para o chamado';
          
          // Aguarda um momento para garantir que o estado foi atualizado
          await new Promise(resolve => setTimeout(resolve, 500));
          
          // Redireciona para os detalhes do chamado
          this.$router.push(`/detalhes/${chamadoId}`);
        } else {
          throw new Error('Falha na autenticação');
        }
      } catch (error) {
        console.error('Erro ao processar autenticação:', error);
        
        this.$swal({
          icon: 'error',
          title: 'Erro ao autenticar',
          text: error.response?.data?.message || 'Não foi possível autenticar. O link pode estar expirado.',
        }).then(() => {
          this.$router.push('/login');
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

.auth-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #00235C 0%, #001a45 100%);
  font-family: 'Inter', sans-serif;
  padding: 2rem;
}

.auth-card {
  background: white;
  border-radius: 24px;
  padding: 3rem 2rem;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 400px;
  width: 100%;
  text-align: center;
}

.spinner-wrapper {
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
}

.spinner {
  animation: rotate 1.5s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.auth-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #00235C;
  margin-bottom: 0.5rem;
}

.auth-subtitle {
  font-size: 1rem;
  color: #6b7280;
  font-weight: 500;
}
</style>
